import api from './api';
import { transformProductList } from '../utils/elasticResultTransformers';

export default {
  getProducts(businessId) {
    return new Promise((resolve, reject) => {
      api
        .get('product', {
          params: {
            category: 'Business Funding',
            businessId: businessId
          }
        })
        .then(response => resolve(response.data.data))
        .catch(error => reject(error.data));
    });
  },
  getProductsByFunder(funderId) {
    return api.get('product', {
      params: {
        orderby: 'name,asc',
        filters: {
          where: [['business_id', '=', funderId]]
        }
      }
    });
  },
  async getProductContent(productId) {
    const response = await api.get(`product/${productId}/content`);
    return response.data;
  },
  updateProduct(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`product/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addProduct(product) {
    return new Promise((resolve, reject) => {
      api
        .post(`product`, product)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getProductsList() {
    const params = {
      paginate: 500,
      page: 1,
      orderby: [{ 'name.raw': 'asc' }],
      search: null,
      filters: {},
      terms: {},
      ranges: [],
      fields: {
        ...['id', 'name', 'type.name', 'provider.api_connection_enabled']
      }
    };

    return api.get('product/search', { params }).then(response => ({ data: transformProductList(response.data) }));
  },
  getProductTiers() {
    return api.get('product-tier').then(response => response.data);
  }
};
